module.exports = __webpack_public_path__ + "static/media/8. hdsd website.73880d6f.svg";